import request from 'common/tools/network/request';

// Literal path (tech route socialApiMaintenanceStatus): routing data is not
// guaranteed to be initialized when the first consumer checks the flag.
const STATUS_PATH = '/_/maintenance/social';

// Matches the endpoint's max-age so a browser rarely re-fetches over the
// network; this memo mainly spares the HTTP-cache round-trip.
const RECHECK_INTERVAL = 60 * 1000;

let active = false;
let pending: Promise<boolean> | null = null;
let lastCheck = 0;

/**
 * Social interactions kill-switch (SOCIAL_API_MAINTENANCE). The flag is never
 * baked into pages — HTML the CDN cached before a flag flip would carry a
 * stale value for its whole TTL — so consumers ask this endpoint at the
 * moment they need it: before sending a graph mutation, and on userspace
 * page load. The answer is memoized for RECHECK_INTERVAL; on network failure
 * the last known value stands (fail-open: graph-api rejects writes during
 * maintenance anyway).
 */
export default function checkSocialApiMaintenance(): Promise<boolean> {
  const now = Date.now();
  if (!pending || now - lastCheck > RECHECK_INTERVAL) {
    lastCheck = now;
    pending = request<{ socialApiMaintenance: boolean }>(STATUS_PATH)
      .then(status => {
        active = Boolean(status.socialApiMaintenance);
        return active;
      })
      .catch(() => active);
  }
  return pending;
}
